import { ListPlus, Loader2, X } from 'lucide-react';
import { Button } from '../../ui/button';
import type { EmailLista } from '../../../types/email.types';

interface BarraSelezioneProps {
  quanti: number;
  /** Quanti contatti corrispondono ai filtri, anche fuori dalla pagina. */
  totale: number;
  liste: EmailLista[];
  lavorando: boolean;
  onSelezionaTutti: () => void;
  onAggiungi: (listaId: string) => void;
  onAnnulla: () => void;
}

/**
 * La barra che compare quando si spuntano dei contatti in rubrica: da qui si
 * mettono in una lista. Per toglierli si va nella scheda Liste.
 */
export function BarraSelezione({
  quanti,
  totale,
  liste,
  lavorando,
  onSelezionaTutti,
  onAggiungi,
  onAnnulla,
}: BarraSelezioneProps) {
  if (quanti === 0) return null;

  return (
    <div className="sticky bottom-3 z-20">
      <div className="flex flex-col gap-2 rounded-xl border border-primary-200 bg-white/95 backdrop-blur px-3 py-2.5 shadow-xl sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
          <span className="font-semibold text-gray-900">
            {quanti} {quanti === 1 ? 'selezionato' : 'selezionati'}
          </span>
          {quanti < totale && (
            <button
              type="button"
              onClick={onSelezionaTutti}
              disabled={lavorando}
              className="text-xs text-primary-700 underline underline-offset-2 hover:text-primary-800"
            >
              Seleziona tutti i {totale}
            </button>
          )}
        </div>

        <div className="flex flex-wrap items-center gap-2">
          {lavorando && <Loader2 className="w-4 h-4 animate-spin text-primary-500" />}

          <label className="relative inline-flex items-center">
            <ListPlus className="w-4 h-4 absolute left-2.5 text-neutral-500 pointer-events-none" />
            <select
              value=""
              disabled={lavorando || liste.length === 0}
              onChange={(e) => e.target.value && onAggiungi(e.target.value)}
              className="h-9 rounded-lg border border-gray-200 bg-white pl-8 pr-3 text-sm text-gray-800 disabled:opacity-50"
              aria-label="Metti in una lista"
            >
              <option value="">
                {liste.length === 0 ? 'Crea prima una lista' : 'Metti in una lista…'}
              </option>
              {liste.map((l) => (
                <option key={l.id} value={l.id}>
                  {l.name}
                </option>
              ))}
            </select>
          </label>

          <Button variant="ghost" size="sm" onClick={onAnnulla} disabled={lavorando}>
            <X className="w-4 h-4 mr-1" />
            Annulla
          </Button>
        </div>
      </div>
    </div>
  );
}
